<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Plano Breakdown - Segment Brand Analysis</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="activeModal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body">
  @for (segmentData of reportData; track segmentData) {
    <div class="mb-4">
      <h5 class="mb-3">Segment: {{segmentData.segment}}</h5>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Brand</th>
              <th># SKUs</th>
              <th>SKU%</th>
              <th>Sales%</th>
              <th>Volume%</th>
              <th>Facings%</th>
              <th>Volume% vs Facings%</th>
              <th>Variance</th>
            </tr>
          </thead>
          <tbody>
            @for (row of segmentData.brands; track row; let i = $index) {
              <tr>
                <td>{{i + 1}}</td>
                <td>{{row.brand}}</td>
                <td>{{row.totalSkus}}</td>
                <td>{{row.rangeContribution | number:'1.2-2'}}%</td>
                <td>{{row.salesContribution | number:'1.2-2'}}%</td>
                <td>{{row.volumeContribution | number:'1.2-2'}}%</td>
                <td>{{row.planoFacings | number:'1.2-2'}}%</td>
                <td>{{row.volumeVariance | number:'1.2-2'}}%</td>
              <td [ngClass]="{
                'bg-success': row.varianceColor === 0,
                'bg-warning': row.varianceColor === 1,
                'bg-danger': row.varianceColor === 2
              }"></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>